import { useEffect } from 'react'
import ReactGA from 'react-ga4'

import { DEFAULT_TENANT, GA_EVENTS } from '../constants'

export const useCustomGADimensions = () => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const trackobj: any = {}
    trackobj[GA_EVENTS.TENANT] = DEFAULT_TENANT

    ReactGA.event(GA_EVENTS.TENANT, trackobj)
  }, [])
}
